// order-types.ts

export interface OrderAssemblyPanelProps {
  visible: boolean;
  onClose: () => void;
  projectId: number;
  projectName: string;
  fkProjectActionId?: number | null;
  actionOrders?: any[];
  actionDone?: boolean;
}

export interface SelectedExtension {
  extension: string;
  // quantity is optional while user is picking extensions so it can start blank
  quantity?: number;
}

export interface OrderItemUI {
  key: string;
  reference: string;
  extension: string;
  warehouse: string;
  price_list?: string;
  measure_unit: string;
  quantity: number;
  unit_price: number;
  notes?: string;
  total: number;
}


export interface ModernItemsSectionProps {
  form: any; // antd FormInstance (evitamos importar para no crear coupling)
  onAdd: () => void;
  items: OrderItemUI[];
  columns: any[]; // ColumnsType<OrderItemUI>
  total: number;
  warehouses: { value: string; label: string }[];
  priceLists?: { value: string; label: string }[];
  measureUnits: { value: string; label: string }[];
  onRemove: (key: string) => void;
  loadingAdd: boolean;
  stacked?: boolean;
  isActionDone?: boolean;
  orderReady?: boolean;
  referenceInputRef?: React.MutableRefObject<any>;
  warehouseInputRef?: React.MutableRefObject<any>;
}


export interface SearchSiesaRowProps {
  form: any; // antd FormInstance
  referenceInputRef?: React.MutableRefObject<any>;
  warehouseInputRef?: React.MutableRefObject<any>;
}
